import React, { useEffect, useState } from "react";
import { Row, Col, Modal } from "react-bootstrap";
import { Link } from "react-router-dom";
import Header from "./header";
import Footer from "./footer";
import { salaryRegister, getPayslip } from "../service/dashboard";

const MONTHS = ["","January","February","March","April","May","June","July","August","September","October","November","December"];

const Payslip = () => {
    const [list, setList]             = useState([]);
    const [loading, setLoading]       = useState(true);
    const [payslip, setPayslip]       = useState(null);
    const [modalShow, setModalShow]   = useState(false);
    const [detailLoading, setDetailLoading] = useState(false);

    useEffect(() => {
        const uid = localStorage.getItem("UID");
        const role = localStorage.getItem("Role");
        const empType = role === "5" ? "teacher" : "worker";

        const temp = new FormData();
        temp.append("employee_id",   uid);
        temp.append("employee_type", empType);
        salaryRegister(temp).then((res) => {
            setLoading(false);
            if (res?.status) setList(res.data.items || []);
        });
    }, []);

    function handleView(itemId) {
        setDetailLoading(true);
        setModalShow(true);
        setPayslip(null);
        getPayslip(itemId).then((res) => {
            setDetailLoading(false);
            if (res?.status) setPayslip(res.data);
        });
    }

    const statusColor = (s) => s === "paid" ? "#28a745" : s === "approved" ? "#2d4ac6" : "#6c757d";

    return (
        <div id="mainpage">
            <div className="maincontent">
                <Header />

                <div className="moreheading">
                    <Row className="row-sm">
                        <Col xs={8} className="text-left align-self-end">
                            <h4 className="morehead-text">My Payslips</h4>
                        </Col>
                        <Col xs={4} className="text-right align-self-end">
                            <Link to="/dashboard" className="btn-outline-success red-btn btn-sm">
                                <i className="fa-solid fa-hand-point-left" /> Go Back
                            </Link>
                        </Col>
                    </Row>
                </div>

                <div className="p-3">
                    {loading && (
                        <p className="text-center text-muted mt-4">Loading payslips...</p>
                    )}

                    {!loading && list.length === 0 && (
                        <div className="text-center mt-4">
                            <i className="fas fa-file-invoice-dollar" style={{ fontSize: "48px", color: "#dee2e6" }} />
                            <p className="text-muted mt-2">No payslip records found</p>
                        </div>
                    )}

                    {list.map((item) => (
                        <div
                            key={item.id}
                            style={{
                                borderRadius: "10px",
                                overflow: "hidden",
                                border: "1px solid #dee2e6",
                                marginBottom: "14px",
                                boxShadow: "0 1px 4px rgba(0,0,0,0.07)",
                            }}
                        >
                            {/* Card header */}
                            <div style={{ background: "#2d4ac6", padding: "10px 14px", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                <span style={{ color: "#fff", fontWeight: 600, fontSize: "15px" }}>{item.month_label}</span>
                                <span style={{ background: statusColor(item.status), color: "#fff", borderRadius: "12px", padding: "2px 10px", fontSize: "11px", fontWeight: 500 }}>
                                    {item.status}
                                </span>
                            </div>

                            {/* Card body */}
                            <div style={{ background: "#fff", padding: "12px 14px" }}>
                                <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "6px" }}>
                                    <span style={{ color: "#888", fontSize: "12px" }}>Attendance</span>
                                    <span style={{ fontSize: "13px", fontWeight: 500 }}>{item.present_days} / {item.total_days} days</span>
                                </div>
                                <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "6px" }}>
                                    <span style={{ color: "#888", fontSize: "12px" }}>Gross Salary</span>
                                    <span style={{ fontSize: "13px" }}>₹ {parseFloat(item.gross_salary || 0).toFixed(2)}</span>
                                </div>
                                <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "10px" }}>
                                    <span style={{ color: "#888", fontSize: "12px" }}>Deductions</span>
                                    <span style={{ fontSize: "13px", color: "#dc3545" }}>- ₹ {parseFloat(item.total_deductions || 0).toFixed(2)}</span>
                                </div>
                                <div style={{ borderTop: "1px solid #f0f0f0", paddingTop: "10px", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                    <div>
                                        <div style={{ color: "#888", fontSize: "11px" }}>Net Salary</div>
                                        <div style={{ fontSize: "18px", fontWeight: 700, color: "#145214" }}>₹ {parseFloat(item.net_salary || 0).toFixed(2)}</div>
                                    </div>
                                    <button
                                        onClick={() => handleView(item.id)}
                                        style={{ background: "#2d4ac6", color: "#fff", border: "none", borderRadius: "6px", padding: "7px 14px", fontSize: "13px", fontWeight: 500 }}
                                    >
                                        <i className="fas fa-file-alt me-1" /> View
                                    </button>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>

                {/* Payslip Detail Modal */}
                <Modal show={modalShow} onHide={() => setModalShow(false)} centered>
                    <Modal.Header closeButton>
                        <Modal.Title style={{ fontSize: "16px" }}>
                            {payslip ? `Payslip — ${payslip.month_label}` : "Payslip"}
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body style={{ padding: 0 }}>
                        {detailLoading && <p className="text-center p-3">Loading...</p>}
                        {!detailLoading && payslip && (
                            <div>
                                {/* Employee info */}
                                <div style={{ background: "#f0f3ff", padding: "12px 16px" }}>
                                    {[
                                        ["Employee", payslip.employee_name],
                                        ["Code",     payslip.employee_code],
                                        ["Type",     payslip.employee_type],
                                        ["Bank",     payslip.bank_name || "—"],
                                        ["Account",  payslip.bank_accno || "—"],
                                        ["Days",     `${payslip.present_days} / ${payslip.total_days}`],
                                    ].map(([label, value]) => (
                                        <div key={label} style={{ display: "flex", justifyContent: "space-between", marginBottom: "4px", fontSize: "13px" }}>
                                            <span style={{ color: "#666", fontWeight: 600 }}>{label}</span>
                                            <span style={{ color: "#222" }}>{value}</span>
                                        </div>
                                    ))}
                                </div>

                                {/* Earnings */}
                                <div style={{ padding: "12px 16px 0" }}>
                                    <div style={{ fontWeight: 600, fontSize: "13px", color: "#2d4ac6", marginBottom: "6px" }}>Earnings</div>
                                    {(payslip.details || []).filter((d) => d.component_type === "earning").map((d, i) => (
                                        <div key={i} style={{ display: "flex", justifyContent: "space-between", fontSize: "13px", marginBottom: "4px" }}>
                                            <span style={{ color: "#555" }}>{d.component_name}</span>
                                            <span>₹ {parseFloat(d.amount).toFixed(2)}</span>
                                        </div>
                                    ))}
                                    <div style={{ display: "flex", justifyContent: "space-between", fontWeight: 700, color: "#1a3299", borderTop: "1px solid #e0e7ff", paddingTop: "6px", marginTop: "4px", fontSize: "13px" }}>
                                        <span>Gross Salary</span>
                                        <span>₹ {parseFloat(payslip.gross_salary).toFixed(2)}</span>
                                    </div>
                                </div>

                                {/* Deductions */}
                                {(payslip.details || []).filter((d) => d.component_type === "deduction").length > 0 && (
                                    <div style={{ padding: "12px 16px 0" }}>
                                        <div style={{ fontWeight: 600, fontSize: "13px", color: "#dc3545", marginBottom: "6px" }}>Deductions</div>
                                        {(payslip.details || []).filter((d) => d.component_type === "deduction").map((d, i) => (
                                            <div key={i} style={{ display: "flex", justifyContent: "space-between", fontSize: "13px", marginBottom: "4px" }}>
                                                <span style={{ color: "#555" }}>{d.component_name}</span>
                                                <span style={{ color: "#dc3545" }}>- ₹ {parseFloat(d.amount).toFixed(2)}</span>
                                            </div>
                                        ))}
                                        <div style={{ display: "flex", justifyContent: "space-between", fontWeight: 700, color: "#8b1a1a", borderTop: "1px solid #ffe0e0", paddingTop: "6px", marginTop: "4px", fontSize: "13px" }}>
                                            <span>Total Deductions</span>
                                            <span>- ₹ {parseFloat(payslip.total_deductions).toFixed(2)}</span>
                                        </div>
                                    </div>
                                )}

                                {/* Net Salary */}
                                <div style={{ background: "#2d4ac6", margin: "12px 0 0", padding: "14px 16px", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                    <span style={{ color: "#fff", fontWeight: 600, fontSize: "14px" }}>Net Salary Payable</span>
                                    <span style={{ color: "#fff", fontWeight: 700, fontSize: "20px" }}>₹ {parseFloat(payslip.net_salary).toFixed(2)}</span>
                                </div>

                                <p style={{ textAlign: "center", fontSize: "10px", color: "#aaa", padding: "8px 0 4px" }}>
                                    Computer generated payslip
                                </p>
                            </div>
                        )}
                    </Modal.Body>
                </Modal>
            </div>
            <Footer />
        </div>
    );
};

export default Payslip;
